import { SuperAdminRole } from '@graphql';
import {
  ActivityLogPage,
  AdvisorsPage,
  ForgotPasswordPage,
  LoginPage,
  ManagersPage,
  OrganizationDetailPage,
  OrganizationsPage,
  ResetPasswordPage,
  SettingsPage,
  OrganizationBillingPage,
  TwoFactorAuthFlow,
  UsersPage,
} from '@pages';
import { FC } from 'react';

type Route = Array<{
  path: string;
  component: FC;
  exact: boolean;
  name?: string;
  role?: SuperAdminRole;
}>;

type IRoutes = {
  [key in RouteType]: Route;
};

type AllowedPaths =
  | 'login'
  | 'reset'
  | 'forgot'
  | 'twoFactorAuth'
  | 'organizations'
  | 'advisors'
  | 'organizationDetail'
  | 'organizationBilling'
  | 'settings'
  | 'requests'
  | 'managers'
  | 'activityLog'
  | 'users';

export const paths: { [key in AllowedPaths]: string } = {
  login: '/auth/login',
  reset: '/auth/reset/:tokenId/:userId',
  forgot: '/auth/forgot',
  twoFactorAuth: '/auth/2fa',
  organizations: '/organizations',
  advisors: '/advisors',
  organizationDetail: '/organizations/:id',
  organizationBilling: '/organizations/billing/:id',
  settings: '/settings',
  requests: '/requests',
  managers: '/admins',
  activityLog: '/activity-log',
  users: '/users',
};

const routes: IRoutes = {
  public: [],
  auth: [
    { path: paths.organizations, component: OrganizationsPage, exact: true, name: 'Organizations' },
    { path: paths.advisors, component: AdvisorsPage, exact: true, name: 'Advisors' },
    { path: paths.organizationDetail, component: OrganizationDetailPage, exact: true },
    { path: paths.organizationBilling, component: OrganizationBillingPage, exact: true },
    // { path: paths.requests, component: RequestsPage, exact: true,
    //   name:'Advisor Requests' },
    {
      path: paths.managers,
      component: ManagersPage,
      exact: true,
      name: 'Admins',
      role: SuperAdminRole.Admin,
    },
    {
      path: paths.activityLog,
      component: ActivityLogPage,
      exact: true,
      name: 'Activity Log',
      role: SuperAdminRole.Admin,
    },
    {
      path: paths.users,
      component: UsersPage,
      exact: true,
      name: 'Users',
    },
    {
      path: paths.settings,
      component: SettingsPage,
      exact: true,
      name: 'Global Settings',
      role: SuperAdminRole.Admin,
    },
  ],
  unAuth: [
    { path: paths.login, component: LoginPage, exact: true },
    { path: paths.forgot, component: ForgotPasswordPage, exact: true },
    { path: paths.reset, component: ResetPasswordPage, exact: true },
    { path: paths.twoFactorAuth, component: TwoFactorAuthFlow, exact: true },
  ],
};

export const getRoutes = (type: RouteType, userRole?: SuperAdminRole): Route =>
  routes[type].filter((route) => !route.role || route.role === userRole);
